import { Component, Prop, h } from '@stencil/core';
import { MenuItem } from '../../public-interfaces';
/**
 * Has 2 slots: 'search' and 'notifications'.
 * @slot search - Search component.
 * @slot notifications - Notifications shortcut component.
 */
@Component({
  tag: 'top-bar',
  styleUrl: 'top-bar.css',
  shadow: true,
})
export class TopBar {
  @Prop() menuItems: MenuItem[] = [];
  @Prop() userIcon: string;
  @Prop() userName: string;

  render() {
    return (
      <header>
        <a href="/">
          <img id="logo" src="/SPCSA_Logo.png"></img>
        </a>

        <section>
          <slot name="search"></slot>
          <slot name="notifications"></slot>
          <drop-down menuItems={this.menuItems}>
            {this.userIcon ? (
              <ripple-wrapper slot="trigger">
                <button
                  class="userButton"
                  style={{
                    height: '38px',
                    width: '38px',
                    backgroundImage: `url(${this.userIcon})`,
                    backgroundRepeat: 'no-repeat, repeat',
                    backgroundSize: 'contain',
                    borderRadius: '100%',
                    border: '1px solid var(--border-color)',
                    cursor: 'pointer',
                  }}
                ></button>
              </ripple-wrapper>
            ) : (
              <ripple-wrapper slot="trigger">
              <button
                class="userButton"
                style={{
                  height: '38px',
                  width: '38px',
                  backgroundColor: '#a19c9c',
                  color: 'white',
                  borderRadius: '100%',
                  border: '1px solid var(--border-color)',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: 'medium',
                  fontWeight: 'bold',
                }}
              >
                {this.userName}
              </button>
            </ripple-wrapper>
            )}
          </drop-down>
        </section>
      </header>
    );
  }
}
